import { fromJS } from 'immutable';

import * as ACTIONS from  '../containers/constants';

const initialState = fromJS({});

export function gFriendsReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.GET_GFS:
        return {
        ...state,
        data: action.payload,
        };
	case ACTIONS.GET_GF:
        return {
        ...state,
        data: action.payload,
        };
	case ACTIONS.GET_GPLACES:
        return {
        ...state,
        data: action.payload,
        };
    default:
      return state;
  }
}

//export default gFriendsReducer;

